<template>
    <div class="trip-map-container" />
</template>

<script>
import { logModes, vehicleHelper } from '../../mixins/VehicleMixin'
import { mapHelper } from '../../mixins/MapMixin'

export default {
    name: 'TripMap',
    mixins: [vehicleHelper, mapHelper],
    props: {
        tripResults: {
            type: Array,
            default: () => []
        },
        tripItem: {
            type: Object,
            default: null
        },
        map: {
            type: Object,
            default: null
        },
        showTripInfo: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            trips: [],
            trip: null
        }
    },
    watch: {
        tripResults() {
            this.resetMap()
            this.$nextTick(() => this.initView())
        },
        tripItem() {
            this.resetMap()
            this.$nextTick(() => this.initView())
        },
        map() {
            if (this.map) {
                this.$nextTick(() => this.initView())
            }
        }
    },
    mounted() {
        this.initView()
    },
    methods: {
        initView() {
            if (!this.map) return

            this.trips = this.tripResults
            this.trip = this.tripItem
            if (this.trip && this.trip.geometry) {
                this.drawTrip(this.trip)
                this.$nextTick(() => {
                    if (this.map) {
                        this.map.zoomToGroup(this.TRACE)
                    }
                })
            } else if (this.trips && this.trips.length > 0) {
                this.drawTrips()
            }
        },

        drawTrips() {
            if (!this.map) return

            this.trips.forEach((trip, index) => {
                this.drawTrip(trip, index)
            })
            this.$nextTick(() => {
                if (this.map) {
                    this.map.zoomToGroup(this.TRACE)
                }
            })
        },

        drawTrip(trip, id = 0) {
            if (!this.map || !trip.geometry) return

            let color = '#00FF21' // Default green for work trips
            let width = 3

            switch (trip.mode) {
            case logModes.WORK:
                color = trip.color || '#00FF21'
                width = 5
                break
            case logModes.PROGRAM:
                color = '#2121FF'
                break
            case logModes.RESETTLE:
                color = '#89898a'
                break
            }

            this.map.drawPolyLine(id, this.TRACE, trip.geometry, color, false, false, width, 1)
        },

        resetMap() {
            if (this.map) {
                this.map.removePolylinesByType(this.TRACE)
            }
            this.trips = []
            this.trip = null
        }
    }
}
</script>

<style scoped>
.trip-map-container {
    width: 100%;
    height: 100%;
}
</style>
